export default __webpack_public_path__ + "static/media/coin98logo.d54315c6.svg";